// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';
export const ArrowLeftSvgIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <g
      stroke="#000"
      strokeWidth={7}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path d="M11.661 50h76.678M11 49.698L35 22M35 77.698L21.515 62.135 11 50" />
    </g>
  </svg>
);
